import DiscordButton from './DiscordButton';
import useDetectScrollDirection, { ScrollDirection } from './hooks/useDetectScrollDirection';

const DiscordButtonShownOnScrollUp = () => {
  const scrollDirection = useDetectScrollDirection();
  return <DiscordButton show={scrollDirection === ScrollDirection.up} />;
};

export default DiscordButtonShownOnScrollUp;
